import { useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { notification } from "antd";
import { postData } from "../api";
import { ResetPasswordConfirmUrl } from "../constants/endPoints";

const ResetPassword = () => {
    const { code } = useParams();
    const history = useHistory();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();

        if (password.length < 6) {
            notification.error({
                message: "Erro",
                description: "A senha deve ter pelo menos 6 caracteres"
            });
            return;
        }
        if (password !== confirmPassword) {
            notification.error({
                message: "Erro",
                description: "As senhas não coincidem"
            });
            return;
        }

        setIsSaving(true);
        let response = await postData(ResetPasswordConfirmUrl, { code, password }, true);
        setIsSaving(false);

        if (response && response.data && response.data.status === 'success') {
            notification.success({
                message: "Sucesso",
                description: "Senha redefinida com sucesso. Pode agora iniciar sessão."
            });
            history.push('/login');
        } else {
            notification.error({
                message: "Erro",
                description: "Este link já não é válido. Por favor solicite um novo."
            });
        }
    };

    return (
        <div className="login-page mb-4">
            <div className="login-page-container mt-3">
                <main>
                    <section className="h-100">
                        <div className="container py-5 h-100">
                            <div className="row d-flex align-items-center justify-content-center h-100">
                                <div className="col-12 col-md-6 col-lg-5 text-center mb-4 mb-md-0">
                                    <div className="auth-logo-wrap">
                                        <img src="/external_assets/img/auth_banner.png" className="auth-logo" alt="InfoMotores" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5 offset-lg-1">
                                    <div className="auth-form">
                                        <div className="specials auth-heading">
                                            <h2>Redefinir senha</h2>
                                        </div>
                                        <form onSubmit={submit}>
                                            <div className="form-outline mb-4">
                                                <input
                                                    type="password"
                                                    id="new-password"
                                                    className="form-control form-control-lg"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <label className="form-label" htmlFor="new-password">Nova senha</label>
                                            </div>

                                            <div className="form-outline mb-4">
                                                <input
                                                    type="password"
                                                    id="confirm-password"
                                                    className="form-control form-control-lg"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                                <label className="form-label" htmlFor="confirm-password">Confirmar senha</label>
                                            </div>

                                            <div className="d-grid">
                                                <button type="submit" className="btn btn-primary btn-lg" disabled={isSaving}>
                                                    Guardar nova senha
                                                </button>
                                            </div>
                                            <div className="pt-3 text-center">
                                                <Link to={'/login'}>Voltar ao login</Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}

export default ResetPassword;
